Ext.define('SA.view.menu.ViewAttributeMetadata', {
    alias: 'widget.menu-view-attribute-metadata',
    extend: 'Ext.menu.Item',

    text: 'View Metadata',

    handler() {
        Ext.widget({
            xtype: 'metadata-window',
            attribute: this.attribute,
            autoShow: true
        });
    }
});